<template>
  <Menu
    :expandedKeys.sync="expandedKeys"
    :selectedKey.sync="selectedKey"
    dot
    theme="light"
    size="small"
  >
    <template slot="header">
      <Icon
        class="icon icon-chaxunyinqingfuwu"
        style="font-size: 22px;"
      />QueryEngine
    </template>
    <MenuItem v-for="menu in realMenuList" :key="menu.name" @select="onSelect">
      {{ menu.meta.title }}
      <Menu v-if="menu.children && menu.children.length">
        <MenuItem
          v-for="childMenu in menu.children"
          :key="childMenu.name"
          @select="onSelect"
          >{{ childMenu.meta.title }}</MenuItem
        >
      </Menu>
    </MenuItem>
  </Menu>
</template>
<script>
import { Menu, MenuItem } from 'kpc/components/menu';
import { DISABLE_MENU_ROUTER } from '@/apis/common';
import Icon from 'kpc/components/icon';

export default {
  components: {
    Menu,
    MenuItem,
    Icon
  },
  props: {
    menuList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    routerName: {
      type: String
    }
  },
  data() {
    return {
      expandedKeys: ['3'],
      selectedKey: '3-1'
    };
  },
  watch: {
    routerName() {
      this.selectedKey = this.routerName;
    }
  },
  computed: {
    realMenuList() {
      let isSub =
        window.appLocals.userInfo.iam_user &&
        window.appLocals.userInfo.iam_user.username;
      return this.menuList.filter(item => {
        if (isSub) {
          return item.name && item.meta && !item.meta.isForbiddenSub;
        }
        return item.name && item.meta;
      });
    }
  },
  methods: {
    onSelect(item) {
      if (DISABLE_MENU_ROUTER.includes(this.$route.name)) {
        return;
      }
      let router = {};
      let name = item.get('key');
      if (name === this.routerName) {
        return;
      }
      for (let i = 0; i < this.menuList.length; i++) {
        let menu = this.menuList[i];
        if (menu.children && menu.children.length) {
          for (let j = 0; j < menu.children.length; j++) {
            const cm = menu.children[j];
            if (cm.name === name) {
              router = { ...menu, current: cm };
              break;
            }
          }
        }
        if (router.current) break;
        if (menu.name === name) {
          router = menu;
          break;
        }
      }
      this.$emit('menu-click', router);
    }
  }
};
</script>
